const idPortalApi = "b673ee5a6bff20b57f8ecabaf1e6165b295c3bc9";

module.exports = {
  tokenLink: idPortalApi,
  urlApi: `https://api-portais-workcenter.com.br/${idPortalApi}`,
  link: "http://www.transparenciadministrativa.com.br",
  urlADM: `https://administracaopublica.com.br`,
  linkArquivos: "http://www.transparenciadministrativa.com.br/portalimagem",
  imagemURL: "https://cdn.administracaopublica.com.br/complementares/",

  // urlApi: `http://localhost:8004/${idPortalApi}`,
  //imagemURL: 'http://localhost:8004/uploads/', //link para a imagem

  urlEmDeploy: "https://camaratanquedopiaui.pi.gov.br/", //usada para link de compartilhamento
  dnsPortal: "camaratanquedopiaui.pi.gov.br",
  NomePortal: "Tanque do Piauí",
  ufPortal: "PI",
  NomeTipoPortal: "Câmara Municipal", //Prefeitura ou Câmara
  TipoPortal: 4, //3 = Prefeitura 4 = Câmara

  //Variável em teste (newsViewRoute)
  newsViewRoute: true,
  countNewsHome: 6, //quantidade de noticias na home
  RoutesDaily: true, //Deixa ativado as rotas para a pagina de diario
  corIcones: "#b28e08",

  //links externos
  link_youtube: `#`,
  link_localize: `https://maps.app.goo.gl/dBQSPf2PR4DCnbSQA`,
  //Mapa da pagina Municipio/Mapa
  link_mapa:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3963.3929963254504!2d-42.286548022060444!3d-6.597983475944689!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x79b41c8bc1abc03%3A0xd9dac87f16d0b2a0!2sCamara%20Municipal%20de%20Tanque%20do%20Piau%C3%AD!5e0!3m2!1sen!2sbr!4v1736956440990!5m2!1sen!2sbr",
};
